<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";

import { mapGetters, mapActions } from "vuex";
import { required, minLength, maxLength, url } from "vuelidate/lib/validators";
import DropzonePopup from "../../../components/widgets/dropzone-popup";
import { alpha } from "@/helpers/helper";

//import store from '@/state/store'
/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Events",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    DropzonePopup,
  },
  data() {
    return {
      event: {
        name: "",
        date: "",
        start_time: "",
        end_time: "",
        type: "",
        image: "",
        website: "",
        address: "",
        status: true,
      },
      value: "",
      urlSeen: false,
      addressSeen: false,
      isActive: false,
      color: {
        "text-danger": true,
      },
      title: "Events",
    };
  },
  validations: {
    event: {
      name: {
        required,
        alpha,
        minLength: minLength(3),
        maxLength: maxLength(100),
      },
      date: { required },
      start_time: { required },
      end_time: { required },
      type: { required },
      address: {
        minLength: minLength(3),
        maxLength: maxLength(1000),
      },
      website: {
        url,
      },
    },
  },
  computed: mapGetters("event", [
    "loading",
    "eventCount",
    "eventData",
    "events",
    "paginations",
  ]),
  methods: {
    ...mapActions("event", ["createEvent"]),
    create() {
      this.$v.event.$touch();
      if (this.$v.event.$invalid) {
        this.isActive = false;
        return;
      } else {
        this.isActive = true;
        var data = this.event;
        
        this.createEvent(data).then((res) => {
         
          if (res == true) {
            this.isActive = true;
            this.$router.push({ name: "event.list" });
          } else {
            this.isActive = false;
          }
        });
      }
    },
    onChange(event) {
      this.value = event.target.value;
      if (this.value === "Online") {
        this.urlSeen = true;
        this.addressSeen = false;
      } else if (this.value === "Offline") {
        this.urlSeen = false;
        this.addressSeen = true;
      } else {
        this.urlSeen = true;
        this.addressSeen = true;
      }
    },
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="text-left mb-4">
          <a href="#" class="router-link-active" @click="$router.back()">
            <i class="bx bx-arrow-back"></i>
            Back
          </a>
        </div>
        <div class="card">
          <div class="card-header">
            <div
              class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
            >
              <div class="page-title-left avatar-main-icon" style="display: flex">
                <div class="avatar-xs mr-3">
                  <span
                    class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                  >
                    <i class="bx bx-user-circle"></i>
                  </span>
                </div>
                <div class="report-tag">
                  <h4 class="mb-0 font-size-18">ADD EVENTS</h4>
                  <p>
                    <router-link :to="{ name: 'event.list' }">Event </router-link>
                    > Add Event
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <form @submit.prevent="create">
              <div class="row">
                <div class="col-6 mb-2">
                  <div class="form-group">
                    <label>Name<span :class="color">*</span></label>
                    <input
                      type="text"
                      class="form-control"
                      name="name"
                      v-model="event.name"
                      :class="{ 'is-invalid': $v.event.name.$error }"
                      placeholder="Name"
                    />
                    <div v-if="$v.event.name.$error" class="invalid-feedback">
                      <span v-if="!$v.event.name.required"> Please enter name</span>
                      <span v-if="!$v.event.name.minLength">
                        {{ $t("Name should not less than 3") }}</span
                      >
                      <span v-if="!$v.event.name.maxLength">
                        {{ $t("Name should not more than 100") }}</span
                      >
                    </div>
                  </div>
                </div>

                <div class="col-6 mb-2">
                  <b-form-group
                    id="example-date"
                    label="Date"
                    label-for="date"
                    label-class="required"
                  >
                    <b-form-input
                      class="form-control"
                      v-model="event.date"
                      id="date"
                      type="date"
                      :class="{ 'is-invalid': $v.event.date.$error }"
                    ></b-form-input>
                    <div v-if="$v.event.date.$error" class="invalid-feedback">
                      <span v-if="!$v.event.date.required"> Please select date</span>
                    </div>
                  </b-form-group>
                </div>

                <div class="col-6 mb-2">
                  <b-form-group
                    id="start_time"
                    label="Start Time"
                    label-for="start"
                    label-class="required"
                  >
                    <b-form-input
                      class="form-control"
                      v-model="event.start_time"
                      id="start_time"
                      type="time"
                      :class="{ 'is-invalid': $v.event.start_time.$error }"
                    ></b-form-input>
                    <div v-if="$v.event.start_time.$error" class="invalid-feedback">
                      <span v-if="!$v.event.start_time.required">
                        Please select start time</span
                      >
                    </div>
                  </b-form-group>
                </div>

                <div class="col-6 mb-2">
                  <b-form-group
                    id="end_time"
                    label="End Time"
                    label-for="end"
                    label-class="required"
                  >
                    <b-form-input
                      class="form-control"
                      v-model="event.end_time"
                      id="end_time"
                      type="time"
                      :class="{ 'is-invalid': $v.event.end_time.$error }"
                    ></b-form-input>
                    <div v-if="$v.event.end_time.$error" class="invalid-feedback">
                      <span v-if="!$v.event.end_time.required">
                        Please select end time</span
                      >
                    </div>
                  </b-form-group>
                </div>

                <div class="col-12 mb-2">
                  <div class="form-group">
                    <label>Type<span :class="color">*</span></label>
                    <select
                      class="form-select form-control"
                      v-model="event.type"
                      name="type"
                      :class="{ 'is-invalid': $v.event.type.$error }"
                      @change="onChange($event)"
                    >
                      <option value="" disabled>Select Type</option>
                      <option value="Online">Online</option>
                      <option value="Offline">Offline</option>
                      <option value="Hybrid">Hybrid</option>
                    </select>
                    <div v-if="$v.event.type.$error" class="invalid-feedback">
                      <span v-if="!$v.event.type.required"> Please select type</span>
                    </div>
                  </div>
                </div>
                <div class="col-12 mb-2" v-if="urlSeen">
                  <div class="form-group">
                    <label>Website URL</label>
                    <input
                      type="url"
                      class="form-control"
                      name="website"
                      :class="{ 'is-invalid': $v.event.website.$error }"
                      :placeholder="$t('Website URL')"
                      v-model="event.website"
                    />
                    <div v-if="$v.event.website.$error" class="invalid-feedback">
                      <span v-if="!$v.event.website.url">
                        {{ $t("Enter valid url") }}</span
                      >
                    </div>
                  </div>
                </div>
                <div class="col-12 mb-2" v-if="addressSeen">
                  <div class="form-group">
                    <label>Address</label>
                    <textarea
                      rows="5"
                      cols="159"
                      name="address"
                      v-model="event.address"
                      class="form-control"
                      :class="{ 'is-invalid': $v.event.address.$error }"
                      placeholder="Address"
                    ></textarea>
                    <div v-if="$v.event.address.$error" class="invalid-feedback">
                      <span v-if="!$v.event.address.minLength">
                        {{ $t("Address should not less than 3") }}</span
                      >
                    </div>
                  </div>
                </div>

                <div class="col-6 mb-2">
                  <div class="form-group">
                    <label>Profile</label>
                    <dropzone-popup
                      v-model="event.image"
                      id="image"
                      name="image"
                      acceptedFiles=".jpeg,.jpg,.png"
                    />
                    <!-- <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"></vue-dropzone> -->
                  </div>
                </div>

                <div class="col-6 mb-2">
                  <div class="form-group">
                    <label>Status</label>
                    <b-form-checkbox
                      switch
                      size="lg"
                      v-model="event.status"
                      class="ml-1"
                    ></b-form-checkbox>
                  </div>
                </div>

                <div class="col-12 pt-4">
                  <button type="submit" class="btn btn-primary" :disabled="isActive">
                    Save
                  </button>
                  <b-button
                    @click="$router.back()"
                    type="button"
                    variant="secondary"
                    class="ml-3"
                    >Cancel
                  </b-button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.form-select {
  -moz-padding-start: calc(0.75rem - 3px);
  -webkit-appearance: none;
  appearance: none;
  background-color: #fff;
  background-image: url(/images/download.svg);
  background-position: right 0.75rem center;
  background-repeat: no-repeat;
  background-size: 16px 12px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  color: #495057;
  display: block;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5;
  padding: 0.47rem 1.75rem 0.47rem 0.75rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  width: 100%;
}
</style>
